module.exports = __webpack_public_path__ + "static/webhooks_table-845b281e589e3609d8c4dd9557cdfcbe.png";